import { render, staticRenderFns } from "./account_ali.vue?vue&type=template&id=aa05bee0&scoped=true&"
import script from "./account_ali.vue?vue&type=script&lang=js&"
export * from "./account_ali.vue?vue&type=script&lang=js&"
import style0 from "./account_ali.vue?vue&type=style&index=0&id=aa05bee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa05bee0",
  null
  
)

export default component.exports